module.exports = {
    searchSettings: {
        searchRequest: {
            search: '',
            select:
                'Code, GrossPriceInfoPrice, ShortDescription, CommercialDescription, Image, GrossPriceInfoPriceQuantity, GrossPriceInfoPriceUnitCode, IsWebShopItem, ModificationCode, PriceUnitDescription, PriceUnitPluralDescription, PriceOrderRatio, UrlPart', // Verkorte_omschrijving_Saniceve_BV, ProductDescription, ProductBrand, ProductSeries, ProductType, ProductCode, Image, GrossPriceInfoPrice, UDF_vrdsoort',
            filter: '',
            orderBy: '',
            top: 12,
            skip: 0,
            count: true,
            highlight: '',
            highlightPreTag: '',
            highlightPostTag: '',
            facets: [
                //  'ProductBrand,count:10000,sort:value',
                //  'ProductSeries,count:10000,sort:value',
                //  'ProductType,count:10000,sort:value',
                //  'ProductClassName,count:10000,sort:value',
            ],
			queryType: 'simple',
			searchMode: 'all'
        },
        facets: [
            //  {
            //    title: 'Merk',
            //    field: 'ProductBrand',
            //    textTop: '',
            //    textBottom: '',
            //    tooltipText: '',
            //    valueType: 0,
            //    facetMode: 0,
            //    expanded: true,
            //    showMore: false,
            //    showMoreAfter: 5,
            //    facetValueOverrides: null,
            //    sliderSettings: null,
            //  },
            //  {
            //    title: 'Serie',
            //    field: 'ProductSeries',
            //    textTop: '',
            //    textBottom: '',
            //    tooltipText: '',
            //    valueType: 0,
            //    facetMode: 0,
            //    expanded: true,
            //    showMore: false,
            //    showMoreAfter: 5,
            //    facetValueOverrides: null,
            //    sliderSettings: null,
            //  },
            //  {
            //    title: 'Type',
            //    field: 'ProductType',
            //    textTop: '',
            //    textBottom: '',
            //    tooltipText: '',
            //    valueType: 0,
            //    facetMode: 0,
            //    expanded: true,
            //    showMore: false,
            //    showMoreAfter: 5,
            //    facetValueOverrides: null,
            //    sliderSettings: null,
            //  },
            //  {
            //    title: 'Klasse',
            //    field: 'ProductClassName',
            //    textTop: '',
            //    textBottom: '',
            //    tooltipText: '',
            //    valueType: 0,
            //    facetMode: 0,
            //    expanded: true,
            //    showMore: false,
            //    showMoreAfter: 5,
            //    facetValueOverrides: null,
            //    sliderSettings: null,
            //  },
        ]
    },
    facetSettings: [
        //  {
        //    key: 'ProductBrand',
        //    value: 'String',
        //  },
        //  {
        //    key: 'ProductSeries',
        //    value: 'String',
        //  },
        //  {
        //    key: 'ProductType',
        //    value: 'String',
        //  },
        //  {
        //    key: 'ProductClassName',
        //    value: 'String',
        //  },
    ],
    ready: false,
    items: [],
    searched: false,
    filtered: false,
    facets: [],
    facetValueOverrides: [],
    checkedFacets: [],
    initialFacets: [],
    initialSearch: true,
    noResults: false,
    count: 1,
    currentPage: 1,
    pageSize: 12,
    itemsPerPage: 12,
    gridView: false
};
